import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function Close() {
  return /*#__PURE__*/_jsx("div", {
    className: styles['close'],
    "data-testid": "MainButtonClose"
  });
}